import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

// TypeScript interfaces for styled component props
interface CardProps {
  index: number;
}

interface CardTextProps {
  cardIndex: number;
}

interface CardTitleProps {
  cardIndex: number;
}

export const StyledSection = styled(Section)`
  order: 7;
  background: #1c1c1c !important;
  padding: 40px 0px !important;
  margin: 0px !important;

  ${media.md`
    padding: 60px 0px !important;
  `}

  ${media.xl`
    padding: 100px 0px !important;
  `}
`;

export const StyledContentBlock = styled.div`
  max-width: 1440px;
  padding: 0px !important;
  margin: auto;
`;

export const MainContainer = styled.div`
  padding: 0px 20px !important;

  ${media.md`
    padding: 0px 60px !important;
  `}

  ${media.xl`
    padding: 0px 80px !important;
  `}
`;

export const Title = styled.h2`
  color: #ffffff;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 50px;
  font-weight: 900;
  line-height: 87%;
  letter-spacing: -1.04px;

  text-align: center;
  margin: 0px;

  ${media.xl`
    font-size: 90px;
    font-weight: 900;
    line-height: 87%;
    letter-spacing: -1.8px;
  `}
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 20px;
  margin: 40px 0px 0px;

  ${media.md`
    margin: 80px 0px 0px;
  `}

  ${media.lg`
    flex-direction: row;
    margin: 80px 0px 0px;
  `}

  ${media.xl`
    margin: 100px 0px 0px;
  `}
`;

export const ImageSection = styled.div`
  position: relative;
  width: 100%;
  height: 184px;
  background: #ff9500;
  border-radius: 10px;

  ${media.md`
    height: 324px;
  `}

  ${media.lg`
    width: calc(50% - 10px);
    height: 360px;
    border-radius: 20px;
  `}

  ${media.xl`
    height: 480px;
  `}
`;

export const Image = styled.img`
  display: none;

  ${media.lg`
    display: flex;
    width: 460px;
    height: auto;
    position: absolute;
    top: -45px;
    left: 0px;
  `}

  ${media.xl`
    width: 630px;
    height: auto;
    top: -75px;
    left: 0px;
  `}
`;

export const ImageTablet = styled.img`
  display: none;

  ${media.md`
    display: flex;
    width: 570px;
    height: auto;
    position: absolute;
    top: -53px;
    left: 0px;
  `}

  ${media.lg`
    display: none;
  `}
`;

export const ImageMobile = styled.img`
  display: flex;
  width: 260px;
  height: auto;
  position: absolute;
  top: -22px;
  left: 0px;

  ${media.md`
    display: none;
  `}
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  width: 100%;

  ${media.lg`
    width: calc(50% - 10px);
  `}
`;

export const SubSection = styled.a`
  width: 100%;
  cursor: pointer;
  text-decoration: none;
`;

export const SubMainWrapper = styled.div`
  width: calc(100% - 40px);
  background: #faf2e8;
  border-radius: 10px;
  padding: 20px;

  ${media.md`
    width: calc(100% - 60px);
    border-radius: 20px;
    padding: 30px;
  `};
`;

export const SubWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 25px;
`;

export const LogoImage = styled.img`
  width: 80px;
  height: 80px;

  ${media.md`
    width: 140px;
    height: 140px;
  `}

  ${media.xl`
    width: 196px;
    height: 196px;
  `}
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  height: auto;

  ${media.md`
    height: 140px;
  `}

  ${media.lg`
    height: 140px;
  `}

  ${media.xl`
    height: 196px;
  `}
`;

export const SubText = styled.p`
  color: #1c1c1c;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 20px;
  font-weight: 900;
  line-height: 95%;
  letter-spacing: -0.38px;

  text-align: start;
  margin: 0px;

  ${media.md`
    font-size: 34px;
    font-weight: 900;
    line-height: 89%;
    letter-spacing: -0.68px;
  `}

  ${media.lg`
    font-size: 22px;
    font-weight: 900;
    line-height: 89%;
    letter-spacing: -0.68px;
  `}

  ${media.xl`
    font-size: 34px;
    font-weight: 900;
    line-height: 89%;
    letter-spacing: -0.68px;
  `}
`;

export const ButtonTextWrapper = styled.div`
  display: none;

  ${media.md`
    display: flex;
    justify-content: start;
    align-items: center;
    cursor: pointer;
    gap: 10px;
  `}
`;

export const ButtonText = styled.p`
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 140%;

  ${media.xl`
    font-size: 20px;
    font-weight: 500;
    line-height: 130%;
  `}
`;

export const GoArrowButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff9500;
  width: 48px;
  height: 48px;
  border-radius: 50px;

  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: fill 0.3s ease;
  border-radius: 50%;

  &:hover {
    background: #ff7c18;
  }

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple-animation 1.5s ease-out;
    background-color: rgba(204, 85, 0, 0.6);
    pointer-events: none;
    z-index: 0;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }

  ${media.lg`
    width: 56px;
    height: 56px;
  `}
`;

export const ButtonTextWrapperMobile = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  cursor: pointer;
  margin: 10px 0px 0px;
  gap: 10px;

  ${media.md`
    display: none;
  `}
`;

export const CardSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 20px;
  margin: 20px 0px 0px;

  ${media.md`
    flex-direction: row;
  `}
`;

export const CardLink = styled.a`
  width: 100%;
  cursor: pointer;
  text-decoration: none;

  ${media.md`
    width: calc(33.33% - 6.67px);
  `}

  ${media.lg`
    width: calc(33.33% - 13.33px);
  `}

  ${media.xl`
    width: calc(33.33% - 13.33px);
  `}
`;

export const Card = styled.div<CardProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  width: calc(100% - 20px);
  gap: 8px;
  padding: 10px;
  border-radius: 10px;
  ${props => {
    if (props.index === 0) return `background: var(--blue-500, #4169E1);`;
    if (props.index === 1) return `background: var(--orange-500, #FF9500);`;
    if (props.index === 2) return `background: var(--Grey-Scale-50, #F0F0F5);`;
    return `background: var(--blue-500, #4169E1);`;
  }}

  ${media.md`
    width: calc(100% - 40px);
    height: 120px;
    padding: 20px;
  `}

  ${media.lg`
    width: calc(100% - 40px);
    height: 100px;
    border-radius: 20px;
    padding: 20px;
  `}

  ${media.xl`
    width: calc(100% - 60px);
    height: 144px;
    padding: 30px;
  `}
`;

export const CardTitle = styled.h3<CardTitleProps>`
  color: ${props => (props.cardIndex === 2 ? '#1c1c1c' : '#ffffff')};
  font-family: 'Elza Condensed', sans-serif;
  font-size: 52px;
  font-weight: 900;
  line-height: 85%;
  letter-spacing: -0.52px;
  text-align: center;

  margin: 0px;

  ${media.md`
    font-size: 70px;
    font-weight: 900;
    line-height: 85%;
    letter-spacing: -0.68px;
  `}

  ${media.lg`
    font-size: 54px;
    font-weight: 900;
    line-height: 85%;
    letter-spacing: -1.23px;
  `}

  ${media.xl`
    font-size: 78px;
    font-weight: 900;
    line-height: 85%;
    letter-spacing: -0.97px;
  `}
`;

export const CardText = styled.p<CardTextProps>`
  color: ${props => (props.cardIndex === 2 ? '#1c1c1c' : '#ffffff')};
  font-family: 'Elza Condensed', sans-serif;
  font-size: 24px;
  font-weight: 900;
  line-height: 87%;
  letter-spacing: -0.46px;
  text-align: center;

  margin: 0px;

  ${media.md`
    font-size: 30px;
    font-weight: 900;
    line-height: 87%;
    letter-spacing: -0.46px;
  `}

  ${media.lg`
    font-family: 'Satoshi Variable Medium', sans-serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 123%;
  `}

  ${media.xl`
    font-size: 22px;
    font-weight: 500;
    line-height: 123%;
  `}
`;
